import React,{Component} from 'react';
import './KPIs.css';

import Page from '@acri-tools/react-tools/components/Page/Page';

import { kpiBanner, logo } from '../../_utils/images';
import routes from '../../_utils/routes';
import Footer from '../../components/Footer/Footer';
import { go_back, push_history } from '@acri-tools/react-tools/utils/global';

interface Props{
    title: string
}
interface State{
}

// ALL KPI PAGES WRAPPER
export default class KPIs extends Component<Props, State> {
    render(){
        return (
        <Page 
            id="kpis"
            title={this.props.title}
            footer={<Footer/>}
            banner={{
                bannerImage: kpiBanner,
                topBar:{
                    routes: routes,
                    logo: logo,
                    // backTo:`/kpi`
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding kpi">
                    <div className="kpi-banner">
                        <div 
                            className="kpi-back" 
                            onClick={()=>{ 
                                // go_back()
                                push_history(`/kpi`)
                            }}
                        >
                            <i className="fas fa-chevron-left"/> Back
                        </div>
                        <div className="kpi-title">
                            { this.props.title }
                        </div>
                    </div>
                    <div className="kpi-content">
                    {
                        this.props.children
                    }
                    </div>
                </div>
            </div>
        </Page>
        );
    }
};